module.exports = __webpack_public_path__ + "img/logo.a88a4ec8.svg";